module.exports = __webpack_public_path__ + "img/magic-mellow.4a3abc7c.png";